import React from 'react';
import PropTypes from 'prop-types';
import { Card as MuiCard, CardContent, CardActions, CardHeader, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// Component scope - Constants and static data
const CARD_VARIANTS = ['elevation', 'outlined'];

/**
 * App Card Component - Wrapper for MUI Card
 * @component
 * @param {Object} props - Component props
 * @returns {React.ReactElement} AppCardComponent
 */
const AppCardComponent = ({
  variant = 'elevation',
  elevation = 1,
  children,
  title,
  subheader,
  action,
  onBack,
  content,
  actions,
  ...props
}) => {
  // Return/rendering
  return (
    <MuiCard
      variant={variant}
      elevation={elevation}
      {...props}
    >
      {title && (
        <CardHeader
          avatar={
            onBack ? (
              <IconButton
                onClick={onBack}
                sx={{
                  color: 'white',
                  padding: 0,
                  marginRight: 1,
                  '&:hover': { backgroundColor: 'transparent', opacity: 0.8 }
                }}
              >
                <ArrowBackIcon sx={{ fontSize: '1.2rem' }} />
              </IconButton>
            ) : null
          }
          title={title}
          subheader={subheader}
          action={action}
        />
      )}
      {content && <CardContent sx={{ padding: 0 }}>{content}</CardContent>}
      {!content && children && <CardContent>{children}</CardContent>}
      {actions && <CardActions>{actions}</CardActions>}
    </MuiCard>
  );
};

AppCardComponent.propTypes = {
  variant: PropTypes.oneOf(CARD_VARIANTS),
  elevation: PropTypes.number,
  children: PropTypes.node,
  title: PropTypes.string,
  subheader: PropTypes.string,
  action: PropTypes.node,
  onBack: PropTypes.func,
  content: PropTypes.node,
  actions: PropTypes.node,
  sx: PropTypes.object,
  onClick: PropTypes.func,
};

export default AppCardComponent;

